module.exports = __webpack_public_path__ + "img/services_loop.1c8103db.png";